import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EventMetricsDialogData {
  eventTitle: string;
  eventId: string | number;
  gm_video_attendees: number | string;
  teams_attendees: number | string;
  virtual_events_attendees: number | string;
  venue_attendees: number | string;
}

@Component({
  selector: 'app-event-metrics-dialog',
  templateUrl: './event-metrics-dialog.component.html',
  styleUrls: ['./event-metrics-dialog.component.scss'],
  standalone: false
})
export class EventMetricsDialogComponent {
  metrics: { label: string; value: number; icon: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<EventMetricsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EventMetricsDialogData
  ) {
    this.metrics = [
      { label: 'GM Video', value: Number(data.gm_video_attendees) || 0, icon: 'ondemand_video' },
      { label: 'Teams', value: Number(data.teams_attendees) || 0, icon: 'videocam' },
      { label: 'Virtual Events', value: Number(data.virtual_events_attendees) || 0, icon: 'computer' },
      { label: 'Venue', value: Number(data.venue_attendees) || 0, icon: 'location_on' },
    ];
  }

  close(): void {
    this.dialogRef.close();
  }
}
